import { Grid, theme } from '@zappyrent/hundop';
import React from 'react';
import Media from 'react-media';

import {
  StyledImageOuterWrapper,
  StyledTextInnerWrapper,
  StyledTextOuterWrapper,
  StyledWrapper,
} from './DiscoverZappyrent.styles';
import DiscoverZappyrentHeading from './DiscoverZappyrentHeading';
import DiscoverZappyrentImage from './DiscoverZappyrentImage';
import DiscoverZappyrentText from './DiscoverZappyrentText';

const DiscoverZappyrent = (): JSX.Element => {
  return (
    <Media
      queries={{
        mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
        desktop: `(min-width: ${theme.breakpoints.l})`,
      }}
      defaultMatches={{ desktop: true }}
    >
      {matches => (
        <>
          {matches.mobile && (
            <>
              <DiscoverZappyrentHeading />
              <DiscoverZappyrentImage />
              <DiscoverZappyrentText />
            </>
          )}
          {matches.desktop && (
            <StyledWrapper>
              <StyledTextOuterWrapper>
                <Grid container>
                  <StyledTextInnerWrapper>
                    <DiscoverZappyrentHeading />
                    <DiscoverZappyrentText />
                  </StyledTextInnerWrapper>
                </Grid>
              </StyledTextOuterWrapper>
              <StyledImageOuterWrapper>
                <DiscoverZappyrentImage />
              </StyledImageOuterWrapper>
            </StyledWrapper>
          )}
        </>
      )}
    </Media>
  );
};

export default DiscoverZappyrent;
